import { generateDefaultAddress } from '../Address/Address';
import { transformStrapiAddressToAddress } from '../Address/AddressTransformers';
import { transformToBlock } from '../Block/BlockTransformers';
import { transformToDay } from '../Date/DateTransformers';
import { defaultMapLatLng, StoreLocation } from '../Map/Map';
import { transformToImage } from '../Media/MediaTransformers';
import { transformToSeo } from '../Seo/SeoTransformers';
import {
    AdjustedOpeningHours,
    AdjustedOpeningHoursResource,
    OpeningHours,
    OpeningHoursResource,
    Store,
    StoreResource,
} from './Store';

export const transformToOpeningHours = (resource: OpeningHoursResource): OpeningHours => {
    const day = transformToDay(resource.day);

    return {
        day,
        from: resource.openingHours.from,
        to: resource.openingHours.to,
        closed: resource.openingHours.closed,
    };
};

export const transformToAdjustedOpeningHours = (resource: AdjustedOpeningHoursResource): AdjustedOpeningHours => ({
    name: resource.name || undefined,
    day: resource.day,
    from: resource.openingHours.from,
    to: resource.openingHours.to,
    closed: resource.openingHours.closed,
});

export const transformToStore = (resource: StoreResource): Store => {
    const address = resource.address
        ? transformStrapiAddressToAddress(resource.address)
        : generateDefaultAddress();

    const adjustedOpeningHours = resource.adjustedOpeningHours.map(transformToAdjustedOpeningHours);

    const image = resource.image
        ? transformToImage(resource.image)
        : undefined;

    const openingHours = resource.openingHours.map(transformToOpeningHours);

    const blocks = resource.elements
        ? resource.elements.map(transformToBlock)
        : [];

    const publishedBlocks = blocks.filter(block => block.isPublished);

    const seo = resource.seo
        ? transformToSeo(resource.seo)
        : undefined;

    return {
        id: resource.id,
        title: resource.title || '',
        description: resource.description || '',
        address,
        openingHours,
        adjustedOpeningHours,
        slug: resource.slug || '',
        image,
        blocks: publishedBlocks,
        order: resource.order || 0,
        seo,
    };
};

export const transformToStoreLocation = (resource: StoreResource): StoreLocation => {
    const address = resource.address
        ? transformStrapiAddressToAddress(resource.address)
        : generateDefaultAddress();

    const location = resource.address?.latitude && resource.address.longitude
        ? {
            latitude: resource.address.latitude,
            longitude: resource.address.longitude,
        }
        : defaultMapLatLng;

    return {
        label: resource.title || '',
        location,
        address,
    };
};
